import { Breadcrumbs, Button, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { db } from '../../firebase';
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import "@progress/kendo-theme-default/dist/all.css";
import { Alert } from '@mui/material';
const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  ForeColor,
  BackColor,
  CleanFormatting,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  NumberedList,
  BulletedList,
  Undo,
  Redo,
  FontSize,
  FontName,
  FormatBlock,
  Link,
  Unlink,
  InsertImage,
  ViewHtml,
  InsertTable,
  InsertFile,
  SelectAll,
  Print,
  Pdf,
  AddRowBefore,
  AddRowAfter,
  AddColumnBefore,
  AddColumnAfter,
  DeleteRow,
  DeleteColumn,
  DeleteTable,
  MergeCells,
  SplitCell,
} = EditorTools;

const tools = [
  [Bold, Italic, Underline, Strikethrough],
  [Subscript, Superscript],
  ForeColor,
  BackColor,
  [CleanFormatting],
  [AlignLeft, AlignCenter, AlignRight, AlignJustify],
  [Indent, Outdent],
  [OrderedList, UnorderedList],
  [NumberedList, BulletedList],
  FontSize,
  FontName,
  FormatBlock,
  [SelectAll],
  [Undo, Redo],
  [Link, Unlink, InsertImage, ViewHtml],
  [InsertTable, InsertFile],
  [Pdf, Print],
  [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
  [DeleteRow, DeleteColumn, DeleteTable],
  [MergeCells, SplitCell],
];

function EmailTemp({back}) {
    const [list, setList] = useState([]);
    const [create, setCreate] = useState(false)
    const [title, setTitle]= useState('')
    const [subj, setSubj]= useState('')
    const [text, setText] = useState('');
    const [key, setKey] = useState('');
   const [msg, setMsg] = React.useState(null);
   const [editorValue, setEditorValue] = useState("");

  const onChangeText = e => {
    //setRichText(e.html);
  };

  const handleSubmit = e => {
    e.preventDefault();
    if(key=='')
    {
        let id = db.collection('tmp').doc().id;
        console.log(editorValue)
        db.collection('temp').doc(id).set({
            title,
            subj,
            key:id,
            desc: `${editorValue}`
        })
        setTitle('')
setSubj('')
setEditorValue('')
    }
    else{
         db.collection('temp').doc(key).update({
            title,
            subj,
            desc: `${editorValue}`
        })
        setTitle('')
setSubj('')
setEditorValue('')
    }
    setMsg('Saved successfully')
  };


    useEffect(() => {
     db.collection('temp').where('key','!=',null).onSnapshot(snapshot=>{
        let data = []
        snapshot.forEach(snap=>{
            data.push(snap.data())
        })
        setList(data)
     })
    }, [])
    
  return (
    <div>
    {
        !create?
<>
 <Breadcrumbs aria-label="breadcrumb" style={{background:'white',padding:'1rem',width:'fit-content'}}>
  <a underline="always" onClick={back} style={{cursor:'pointer',color:'blue'}}>
    Templates
  </a>
  <Typography color="text.primary">Custom Templates</Typography>
</Breadcrumbs>
         <div style={{display:'flex', justifyContent:'space-between'}}>
        <Button variant='contained' onClick={()=>{setCreate(true)}}>Create</Button>
    </div>
    
    {
        list.map(data=>{
            return(
                 <Paper style={{display:'flex', justifyContent:'space-between', padding:'2rem'}}>
            <Typography>{data.title}</Typography>
            <div>
                <Button variant='contained' onClick={()=>{
                setKey(data.key)
                setTitle(data.title)
                setSubj(data.subj)
                setEditorValue(data.desc)
                setCreate(true)
                }}>Edit</Button>
            <Button variant='contained' onClick={()=>{
                db.collection('temp').doc(data.key).delete()
                }}>Delete</Button>
            </div>
            
        </Paper>
            );
        })
    }
    </>
    :
    <Paper style={{padding:'1rem'}}>
     <Breadcrumbs aria-label="breadcrumb" style={{background:'white',padding:'1rem',width:'fit-content'}}>
  <a underline="always" onClick={back} style={{cursor:'pointer',color:'blue'}}>
    Templates
  </a>
   <a underline="always" onClick={()=>setCreate(false)} style={{cursor:'pointer',color:'blue'}}>
    Custom Templates
  </a>
  <Typography color="text.primary">View</Typography>
</Breadcrumbs>
    <TextField
    label='Template Name'
    onChange={(e)=>{setTitle(e.target.value)}}
    value={title}
    />
    <br/>
     <br/>
      <TextField
      label='Subject'
      onChange={(e)=>{setSubj(e.target.value)}}
      value={subj}
    />
    <br/>
     <br/>
      <div className="k-flex-grow" style={{ maxWidth: "100%" }}>
         {msg ? (
                    <Alert onClose={() => {setMsg('')}} severity="success">
                       {msg} 
                    </Alert>
                ) : null}
          <form onSubmit={handleSubmit}>
            <Editor
              tools={tools}
              contentStyle={{ height: 200,width:'100%' }}
              onChange={(event) => setEditorValue(event.html)}
              value={editorValue}
            />
            <a style={{color:'red'}}>No more than 500 words</a>
          </form>
          <div style={{display:'flex', gap :'2rem'}}>
          <Button variant='contained' type='submit' onClick={handleSubmit}>Save</Button>
          <Button variant='contained' style={{background:'red'}} onClick={()=>{setCreate(false)}}>Cancel</Button>
          </div>
          
        </div>
     
    </Paper>
    }
    
   
    </div>
  )
}

export default EmailTemp